import PropTypes from "prop-types";

// material-ui
import { CssBaseline } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";

// ========|| Default Theme - Main ||========
const themes = createTheme({
    typography: {
        fontFamily: [
            // "Noto Serif",
            // "Noto Serif Thai",
            // "serif",
            "-apple-system",
            "BlinkMacSystemFont",
            // "Segoe UI",
            // "Roboto",
            // "Helvetica Neue",
            // "Arial",
            // "sans-serif",
            "Apple Color Emoji",
            // "Segoe UI Emoji",
            // "Segoe UI Symbol",
            "Segoe UI",
            "SegoeUI",
            "Roboto",
            "Helvetica Neue",
            "Helvetica",
            "Arial",
            "sans-serif",
        ].join(","),
        //fontSize: 14,
    },
    components: {
        MuiAppBar: {
            styleOverrides: {
                colorPrimary: {
                    backgroundColor: "rgba(255, 255, 255, 1)",
                    // backdropFilter: "blur(8px)",
                },
            },
        },
        MuiButton: {
            defaultProps: {
                disableElevation: true,
            },
        },
        MuiCard: {
            defaultProps: {
                variant: "outlined",
            },
        },
    },
});

const ThemeCustomization = ({ children }) => {
    return (
        <ThemeProvider theme={themes}>
            <CssBaseline />
            {children}
        </ThemeProvider>
    );
};

ThemeCustomization.s = {
    children: PropTypes.node,
};

export default ThemeCustomization;
